export default function CellTable(props: { data: any }) {
  return <span>{props.data}</span>;
}
